import { PurchaseLimitRule } from '@core/dto/purchase-limit-rule.model';
import { PurchaseLimitError } from '@core/enums/purchase-limit-error.enum';
import { MultiplePurchaseLimitRuleItems } from '@core/store/cart/cart-state-models';

export function groupPurchaseLimmitRules(
  rules: PurchaseLimitRule[],
): MultiplePurchaseLimitRuleItems {
  let nonBackorderItems: PurchaseLimitRule[] = [];
  let backorderItems: PurchaseLimitRule[] = [];

  rules.forEach((rule) => {
    if (
      rule.errorCode === PurchaseLimitError.PurchaseLimitBackorderOnly ||
      rule.errorCode === PurchaseLimitError.PurchaseLimitBackorderPartial
    ) {
      backorderItems.push({
        ...rule,
        backorderQuantity: rule.requestedQuantity - rule.allowedQuantity,
      });
    } else {
      nonBackorderItems.push(rule);
    }
  });

  return { backorderItems, nonBackorderItems };
}
